module.exports = __webpack_public_path__ + "static/media/ayudaSalaSubasta.88aebf66.jpg";